__turbopack_context__.v({
  "blockContent": "change-password-form-module-sass-module__frf4Tq__blockContent" + " " + __turbopack_context__.i(77712)["blockContent"],
  "blockFooter": "change-password-form-module-sass-module__frf4Tq__blockFooter" + " " + __turbopack_context__.i(77712)["blockFooter"],
  "changePassword": "change-password-form-module-sass-module__frf4Tq__changePassword",
  "passwordChanged": "change-password-form-module-sass-module__frf4Tq__passwordChanged",
});
